var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M40.5001 46.3999H41.0001V45.8999V31.0502C41.0001 29.089 42.5901 27.5002 44.5501 27.5002C46.5097 27.5002 48.1001 29.089 48.1001 31.0502V49.95C48.1001 51.9112 46.5101 53.5 44.5501 53.5H4.05001C2.08998 53.5 0.5 51.9112 0.5 49.95V9.44963C0.5 7.48883 2.09001 5.89959 4.05001 5.89959H22.9497C24.9097 5.89959 26.4997 7.48883 26.4997 9.44963C26.4997 11.4108 24.9097 12.9997 22.9497 12.9997H8.10002H7.60002V13.4997V45.8999V46.3999H8.10002H40.5001ZM40.5223 2.65381C43.5323 -0.217654 48.2675 -0.217937 51.2779 2.65296C54.2425 5.62206 54.2405 10.4315 51.2733 13.3979L51.2732 13.3979L49.7184 14.9527L38.9711 4.20495L40.5223 2.65381ZM34.4459 8.73148L45.1927 19.4788L27.6683 37.0021L27.668 37.0024C27.4552 37.2155 27.2009 37.3826 26.9207 37.4929L26.9203 37.4931L14.3074 42.4697L14.3073 42.4698C13.7889 42.6745 13.2119 42.6745 12.6929 42.4697L12.6928 42.4697C11.5628 42.024 11.0078 40.7464 11.4538 39.6161L11.4538 39.6161L16.2159 27.5459L16.2168 27.5464L16.4307 27.0031C16.5411 26.7225 16.7077 26.4686 16.9206 26.2568L16.9215 26.2559L34.4459 8.73148Z",
    fill: "white",
    stroke: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8173f6ceefbfb1317f1f2f81871e9ce4.svg";
export { ForwardRef as ReactComponent };